import React from 'react';
import {changeTheme, initialState, PreferencesState, ThemeMode, updatePreferences} from "../app/slices/preferencesSlice.ts";
import {useAppSelector, useAppDispatch} from "../app/store";
import { useLocalStorage } from 'react-use';
export const PREFERENCES_TOKEN_KEY = 'prefsToken';
import { useColorScheme } from '@mui/material/styles';

export default function usePreferences() {

    const [prefsToken, setPrefsToken] = useLocalStorage(PREFERENCES_TOKEN_KEY);

    const dispatch = useAppDispatch()

    let preferencesState = useAppSelector((state) => state.preferences)

    const { setMode } = useColorScheme();

    React.useEffect(() => {
        if (!preferencesState.updated) {
            try {
                const preferences = prefsToken && JSON.parse(prefsToken) || {};
                if (preferences) {
                    preferencesState = preferences;
                    dispatch(updatePreferences(preferences))
                }
            } catch (error) {
                console.error('Failed to read preferences: ', error);
            }
        }
    }, [preferencesState.updated])

    React.useEffect(() => {
        if (preferencesState.updated) {
            setPrefsToken(JSON.stringify(preferencesState))
        }
    }, [preferencesState])

    const prefsChangeThemeMode = React.useCallback((themeMode: ThemeMode) => {
        setMode(themeMode)
        dispatch(changeTheme(themeMode))
    }, [preferencesState])

    return {
        prefsChangeThemeMode,
        ...preferencesState
    }
}

export function usePreferencesState(): PreferencesState {
    let preferencesState = useAppSelector((state) => state.preferences)
    return preferencesState
}
